import { useTranslation } from 'react-i18next';
import { useNodeHighlighting } from '@/features/connect-dots/hooks/useNodeHighlighting';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface StopHighlightButtonProps {
  cytoscapeCoreRefObject: cytoscape.Core | null;
}

export const StopHighlightButton = ({
  cytoscapeCoreRefObject,
}: StopHighlightButtonProps) => {
  const { removeHighlighting } = useNodeHighlighting();
  const { t } = useTranslation();

  // ハイライトされているノードがあるかどうか判定
  const hasHighlightedNodes = Boolean(
    cytoscapeCoreRefObject?.nodes('.highlighted, .theme-highlighted').length
  );

  const handleClick = () => {
    removeHighlighting(cytoscapeCoreRefObject);
  };

  return (
    <>
      {hasHighlightedNodes && (
        <button
          className="flex items-center gap-2 whitespace-nowrap rounded-full bg-rw-red px-4 py-2 text-sm font-medium text-white shadow-lg transition-all duration-200 hover:bg-rw-main hover:shadow-xl"
          disabled={!hasHighlightedNodes}
          onClick={handleClick}
          title={t('選択解除')}
        >
          <XMarkIcon className="size-4" />
          <span>{t('選択解除')}</span>
        </button>
      )}
    </>
  );
};
